
import React from "react";
import { Link } from "react-router-dom";
import { Video, ChevronRight } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import CollapsibleSection from "@/components/dashboard/CollapsibleSection";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

interface ResourcesSectionProps {
  isCollapsed: boolean;
  onToggle: () => void;
}

const ResourcesSection: React.FC<ResourcesSectionProps> = ({ 
  isCollapsed, 
  onToggle 
}) => {
  const { t } = useTranslation('dashboard');
  
  return (
    <CollapsibleSection 
      title={t('sections.resources')} 
      icon={<Video className="text-golf-600" />} 
      isCollapsed={isCollapsed} 
      onToggle={onToggle}
    >
      <div className="grid grid-cols-1 gap-3">
        <Card>
          <CardHeader className="py-4">
            <CardTitle className="text-lg">{t('resources.title')}</CardTitle>
            <CardDescription>
              {t('resources.description')}
            </CardDescription>
          </CardHeader>
          <CardContent className="pt-0 pb-4">
            <Button variant="outline" className="w-full" asChild>
              <Link to="/videos">
                {t('resources.exploreVideos')} <ChevronRight className="ml-1 h-4 w-4" />
              </Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </CollapsibleSection>
  );
};

export default ResourcesSection;
